<template>
    <div class="viewBox">
        <i class="el-icon-loading" v-if="isLoading"></i>
        <el-result icon="success" v-if="resultType==1"></el-result>
        <el-result icon="warning" v-if="resultType==2"></el-result>
        <div class="text-current">
            {{textCurrent}}
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: true,
            textCurrent: "授权绑定中...",
            resultType: 0,
        };
    },
    methods: {
        getGmailAuth(){
            let code = this.$route.query.code || '';
            let state = this.$route.query.state || '';
            if(!code || !state){
                this.isLoading = false;
                this.resultType = 2;
                this.textCurrent = "授权绑定失败，请重试";
                return;
            }
            this.$axios.get(`${this.$mailUrl}/GmailAuth/AuthorizationBinding?code=${code}&state=${state}`).then((res) => {
                const { isSuccess, errorMessage } = res;
                this.isLoading = false;
                if (isSuccess) {
                    this.resultType = 1;
                    this.textCurrent = "授权绑定成功";
                }else{
                    this.resultType = 2;
                    this.textCurrent = errorMessage || "授权绑定失败，请重试";
                }   
            });
        }
    },
    mounted() {
        this.getGmailAuth();  
    },
};
</script>

<style lang='scss' scoped>
.viewBox{
    text-align: center;
    padding-top: 200px;
    color: #3a3a3a;
    .el-icon-loading{
        font-size: 150px;
    }
    .text-current{
        font-size: 28px;
    }
}
</style>    